export type GoalScopeFieldRequirement = 'mandatory' | 'optional';

export const GOAL_SCOPE_CARD1_FIELD_META = {
  studyName: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  studyDescription: {requirement: 'optional' as GoalScopeFieldRequirement},
  productName: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  productCode: {requirement: 'optional' as GoalScopeFieldRequirement},
  industrySector: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  hsnCode: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  reportingOrg: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  studyDate: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  referenceYear: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  intendedApplication: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  productCNCode: {requirement: 'optional' as GoalScopeFieldRequirement},
  pcfStandard: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  audienceSelection: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  fuQuantity: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  fuUnit: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  fuDescription: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  referenceFlow: {requirement: 'optional' as GoalScopeFieldRequirement},
  boundaryScope: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  geographicScope: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  allocationMethod: {requirement: 'mandatory' as GoalScopeFieldRequirement},
  exclusions: {requirement: 'optional' as GoalScopeFieldRequirement}
} as const;

export const isGoalScopeFieldMandatory = (
  field: keyof typeof GOAL_SCOPE_CARD1_FIELD_META
): boolean => GOAL_SCOPE_CARD1_FIELD_META[field].requirement === 'mandatory';
